export const C_Regexp = {
  date: /(\d{2}\.\d{2}\.\d{4})/,
  positiveInteger: /^\d+$/,
  decimalNumber: /^[\d.]*$/,
  multipleDecimalPoints: /\.+/g,
  leadingDecimalPoint: /^\./,
  txPrefix: /^tx/i,
  trailingSlash: /\/$/,
  doubleTrailingSlashes: /\/\/$/,
  numberWith6Decimals: /^\d+(\.\d{1,6})?$/,
  numberWithOptionalDecimalAndCommas: /^[0-9,]*\.?[0-9]*$/,
  dotGlobal: /\./g,
  tokenAmountPattern: '^\\d+(\\.\\d{1,{decimals}})?$',
  numericInput: /^-?\d*\.?\d*$/,
  editorText: /<[^>]*>/g,
  numberOrDot: /[0-9.]/
};
